/**
 * Lê da query string o controle de origem do fluxo de geração de documento modelo.
 * Retorna null quando o fluxo não veio de um controle, o que mantém o comportamento padrão da tela.
 */
const parseControlOrigin = (search) => {
  const searchParams = new URLSearchParams(search)

  const governanceProjectId = searchParams.get('governanceProjectId')
  const activityId = searchParams.get('activityId')
  const evidenceId = searchParams.get('evidenceId')

  if (!governanceProjectId || !activityId || !evidenceId) return null

  return { governanceProjectId, activityId, evidenceId }
}

export default parseControlOrigin
